import { Controller } from "stimulus";

export class TaxiController extends Controller {
}
